<div class="flex flex-col flex-auto task-form-wrapper">
  <form [formGroup]="propertyUnitForm">
    <div class="header">
      <!-- Mark as ... button -->
      <span class="px-4">
        <strong>{{ propertyUnit.property_tenant.name }}</strong>
        <label></label>
      </span>

      <!-- More menu -->
      <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu">
        <mat-icon [svgIcon]="'more_vert'"></mat-icon>
      </button>

      <mat-menu #moreMenu="matMenu">
        <button mat-menu-item (click)="deletePropertyUnit()">
          <mat-icon [svgIcon]="'delete'"></mat-icon>
          <span>Delete</span>
        </button>
      </mat-menu>

      <!-- Close button -->
      <button mat-icon-button [routerLink]="['../']">
        <mat-icon [svgIcon]="'close'"></mat-icon>
      </button>
    </div>

    <mat-divider></mat-divider>

    <!-- Title -->
    <fieldset [formGroupName]="'property_tenant'">
      <!-- Notes -->
      <!-- TODO: RRS hiding for now -->
      <div class="notes">
        <mat-form-field class="treo-mat-textarea treo-mat-no-subscript">
          <mat-label>Notes</mat-label>
          <textarea matInput treoAutogrow [formControlName]="'description'" [spellcheck]="false"></textarea>
        </mat-form-field>
      </div>
    </fieldset>
  </form>

  <div class="flex flex-col mt-3">
    <div class="files-table">
      <div class="body">
        <div class="row" *ngFor="let fileResource of propertyUnit.property_tenant.file_resources">
          <div class="col">
            <a (click)="downloadDocument(fileResource)">
              <mat-icon class="icon" [svgIcon]="'insert_drive_file'"></mat-icon>
            </a>
          </div>
          <div class="col">
            <a (click)="downloadDocument(fileResource)">{{ fileResource.name }}</a>
          </div>
          <div class="col">{{ fileResource.created_at | date: 'MMM dd, y' }}</div>
          <div class="col">{{ fileResource.user?.full_name }}</div>
          <div class="col">
            <button mat-icon-button class="delete-file" (click)="deleteFile(fileResource)">
              <mat-icon [svgIcon]="'delete'"></mat-icon>
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div>
            <button class="ml-2 xs:hidden add-task" mat-flat-button (click)="fileInput.click()">
              <mat-icon class="icon-size-20 mr-1" [svgIcon]="'backup'"></mat-icon>
              <input style="display: none" type="file" (change)="onFileChanged($event)" #fileInput />
              Upload Attachment
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <comment-view
      [relatedToId]="propertyUnit.property_tenant.id"
      relatedToType="PropertyTenant"
      [account]="account"
    ></comment-view>
  </div>
</div>
